import globals from '../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    roofExhaust: {},
    searchButton: {
        marginTop: 20,
        textAlign: 'right'
    }
});
